export default "__VITE_ASSET__Ce96qHrT__"